import { useTranslation } from 'react-i18next'

import { ProfileInfoWidget } from '../../../Widget'

import { POST_ADDRESS_FIELDS } from './UserProfileWidgetPostAddress.constants'

function UserProfileWidgetPostAddress({
  canEdit,
  data,
  isSkeleton,
  options,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ProfileInfoWidget
      canEdit={canEdit}
      config={POST_ADDRESS_FIELDS}
      data={data}
      isSkeleton={isSkeleton}
      options={options}
      title={t('Widget.PostAddressTitleKey')}
      onSubmit={onSubmit}
    />
  )
}

export default UserProfileWidgetPostAddress
